export default __webpack_public_path__ + "static/media/TC.6ca09bde.svg";